import axios from "axios";
import config from "../config";

export const getApplication = async (id) => {
    const response = await axios.get(`${config.API_BASE_URL}/application/get`, { 
        params: {
            id
        }
    });
    if (response != null) {
        return response.data;
    }
    return null;
}

export const getApplications = async () => {
    const response = await axios.get(`${config.API_BASE_URL}/application/all`);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const createApplication = async (data) => {
    console.log("Creating application with data:", data);
    
    const response = await axios.post(`${config.API_BASE_URL}/application/create`, data, {
      headers: {
        // 'Content-Type': 'multipart/form-data'
      }
    });
    if (response != null) {
        return response.data;
    }
    return null;
}

export const updateApplication = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/application/update`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const deleteApplication = async (id) => {
    const response = await axios.get(`${config.API_BASE_URL}/application/delete`, {
        params: {
            id
        }
    });
    if (response != null) {
        return response.data;
    }
    return null;
}